exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mce-toolbar-grp{height:0;padding:0;overflow:hidden;transition:.3s}.focus .mce-toolbar-grp{height:32px}.mce-panel{border:0}.text-editor{border:1px solid #ebedf2;overflow:hidden;border-radius:4px}div.mce-fullscreen{top:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e0f7284","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/ui/TextEditor.vue
// module id = iltz
// module chunks = 0 1 2